export default __webpack_public_path__ + "static/media/budget-tracker.1d87e37c.png";